var angular = require('angular')

angular.module('AemUniforms')
  .controller('aemUniformsCtrl', ctrl)

ctrl.$inject = ['wgService']

function ctrl (wgService) {
  var vm = this

  vm.$onInit = function () {
    vm.formId = wgService.getParams().formId
    vm.showTitle = wgService.getParams().showTitle
    vm.hideDate = wgService.getParams().hideDate
    vm.theme = wgService.getParams().theme || { baseClass: 'inlet-wrapp', fieldsClasses: {} }
  }
}
